// extracted by mini-css-extract-plugin
export default {"days":"QVmLn","day":"_5J3lF","empty":"MgH18"};